import { render, staticRenderFns } from "./topiccategory.vue?vue&type=template&id=1c289ab0&"
import script from "./topiccategory.vue?vue&type=script&lang=js&"
export * from "./topiccategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports